// extracted by mini-css-extract-plugin
export default {"dragHandleWrapper":"DragAndDropComponent_dragHandleWrapper__aGRbm","dragHandle":"DragAndDropComponent_dragHandle__jzlc8"};